import { defineEndpoint } from '@nzyme/rpc/defineEndpoint.js';
import * as z from 'zod/mini';
import { Id } from '@sigma/common/schema/Id.js';
export const SubscriptionGetStatusEndpointParams = z.object({
    subscriptionId: Id,
});
/**
 * Endpoint to check the status of a subscription.
 * Used by the chat UI to poll for subscription activation after payment.
 */
export const SubscriptionGetStatusEndpoint = defineEndpoint({
    name: 'SubscriptionGetStatus',
    input: SubscriptionGetStatusEndpointParams,
    output: defineEndpoint.output(),
});
//# sourceMappingURL=SubscriptionGetStatusEndpoint.js.map